// The backend may return booleans, 0/1 numbers, or "0"/"1" strings for the same
// field depending on the serializer. This normalizes all of them to a real
// boolean so callers don't repeat (or drift on) the coercion inline.
const isTruthy = (value) => value === true || value === 1 || value === '1';

export { isTruthy };
